// ==============================
// File: src/pages/NotFound.jsx
// 404 Not Found page - does NOT redirect
// ==============================
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  const location = useLocation();
  
  const isDashboard = location.pathname.startsWith('/dashboard');
  const homeLink = isDashboard ? '/dashboard' : '/discover';
  const homeLabel = isDashboard ? 'Back to Dashboard' : 'Back to Discover';
  
  if (import.meta.env.DEV) {
    console.warn(`[404] Page not found: ${location.pathname}`);
  }
  
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        padding: '48px 32px',
        maxWidth: '500px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
      }}>
        <div style={{
          fontSize: '72px',
          fontWeight: 'bold',
          color: '#667eea',
          marginBottom: '16px',
        }}>
          404
        </div>
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#1a202c',
          marginBottom: '12px',
        }}>
          Page Not Found
        </h1>
        
        <p style={{
          color: '#4a5568',
          marginBottom: '8px',
          fontSize: '14px',
        }}>
          The page you're looking for doesn't exist.
        </p>
        
        <p style={{
          color: '#718096',
          fontSize: '12px',
          fontFamily: 'monospace',
          marginBottom: '32px',
          padding: '8px 12px',
          background: 'rgba(0, 0, 0, 0.05)',
          borderRadius: '6px',
          overflowWrap: 'anywhere',
        }}>
          {location.pathname}
        </p>
        
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}>
          <Link
            to={homeLink}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              background: '#667eea',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '14px',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#5a67d8';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#667eea';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <Home size={16} />
            {homeLabel}
          </Link>
          
          <button
            onClick={() => window.history.back()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              background: 'transparent',
              color: '#667eea',
              border: '2px solid #667eea',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(102, 126, 234, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
            }}
          >
            <ArrowLeft size={16} />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
